import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bffe6b96&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bffe6b96&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=bffe6b96&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffe6b96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bffe6b96')) {
      api.createRecord('bffe6b96', component.options)
    } else {
      api.reload('bffe6b96', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bffe6b96&scoped=true", function () {
      api.rerender('bffe6b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/table/input/IkTableNumber/index.vue"
export default component.exports